<div class="flex flex-col flex-auto min-w-0">
    <div class="flex flex-col flex-auto min-w-0 bg-card dark:bg-transparent">
        <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-8 px-6 md:px-8 border-b ">
            <div class="text-4xl font-extrabold tracking-tight">Équipements</div>

            <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
                <button class="ml-4" mat-flat-button [color]="'primary'" (click)="add()">
                    <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                    <span class="ml-2 mr-1">Ajouter</span>
                </button>
            </div>
        </div>

        <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-8 px-6 md:px-8 border-b">
            <mat-form-field class="w-1/4">
                <mat-label>Filtrer par no. d'équipement</mat-label>
                <input type="search" matInput class="form-control" [(ngModel)]="filter">
            </mat-form-field>

        </div>

        <div class="flex flex-auto overflow-hidden">
            <div class="flex flex-col flex-auto overflow-hidden sm:overflow-y-auto">
                <div class="grid">
                    <div class="table-grid-equipements z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <div>No équipement</div>
                        <div class="flex items-center" (click)="sortEquipement('type_equipement')">Type d'équipement
                            <div class="px-2">
                                <mat-icon *ngIf="this.sortValue !== 'type_equipement'">filter_list</mat-icon>
                                <mat-icon *ngIf="this.sortDirection === -1 && this.sortValue === 'type_equipement'">expand_less</mat-icon>
                                <mat-icon *ngIf="this.sortDirection === 1 && this.sortValue === 'type_equipement'">expand_more</mat-icon>
                            </div>
                        </div>
                        <div class="flex items-center" (click)="sortEquipement('statut')">Statut
                            <div class="px-2">
                                <mat-icon *ngIf="this.sortValue !== 'statut'">filter_list</mat-icon>
                                <mat-icon *ngIf="this.sortDirection === -1 && this.sortValue === 'statut'">expand_less</mat-icon>
                                <mat-icon *ngIf="this.sortDirection === 1 && this.sortValue === 'statut'">expand_more</mat-icon>
                            </div>
                        </div>
                        <div class="right-0">Détail</div>
                    </div>
                    <ng-container *ngFor="let equipement of equipements | equipement:filter; trackBy: trackByFn">
                        <div class="table-grid-equipements grid items-center gap-5 py-3 px-6 md:px-8 border-b">
                            <div class="">{{equipement.no_equipement}}</div>
                            <div class="">{{equipement.type_equipement?.nom}}</div>
                            <div class="">{{equipement.statut}}</div>
                            <div class="right-0">
                                <button class="min-w-10 min-h-7 h-7 px-2 leading-6" mat-stroked-button (click)="edit(equipement.id)">
                                    <mat-icon class="icon-size-5" [svgIcon]="currentEquipement?.id === equipement.id ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down'"></mat-icon>
                                </button>
                            </div>
                        </div>
                        <div class="grid">
                            <ng-container *ngIf="currentEquipement?.id === equipement.id">
                                <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: {$implicit: equipement}"></ng-container>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>

                <ng-template #rowDetailsTemplate let-equipement>
                    <div class="shadow-lg overflow-hidden">
                        <div class="flex border-b">
                            <form class="flex flex-col w-full" [formGroup]="equipementForm" (ngSubmit)="onFormSubmit()">
                                <div class="flex flex-col sm:flex-row p-8 pb-0 space-x-4">
                                    <mat-form-field class="w-full">
                                        <mat-label>Numéro de l'équipement</mat-label>
                                        <input type="text" matInput formControlName="no_equipement">
                                    </mat-form-field>
                                    <mat-form-field class="w-full">
                                        <mat-label>Type d'équipement</mat-label>
                                        <mat-select formControlName="type_equipement_id">
                                            <mat-option *ngFor="let typeEquipement of typesEquipements" [value]="typeEquipement.id">{{typeEquipement.nom}}</mat-option>
                                        </mat-select>
                                        <button type="button" class="ml-4" MatSuffix mat-flat-button [color]="'primary'" (click)="ajouterTypeEquipement()">
                                            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                                        </button>
                                    </mat-form-field>
                                </div>

                                <div class="flex flex-col sm:flex-row p-8 pb-0 space-x-4">
                                    <!-- <mat-form-field class="w-full">
                                        <mat-label>Quantité</mat-label>
                                        <input type="text" matInput formControlName="quantite">
                                    </mat-form-field> -->
                                    <mat-form-field class="w-6/12">
                                        <mat-label>Statut</mat-label>
                                        <mat-select formControlName="statut">
                                            <mat-option [value]="'Fonctionnel'">Fonctionnel</mat-option>
                                            <mat-option [value]="'Non fonctionnel'">Non fonctionnel</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="flex items-center justify-between w-full border-t px-8 py-4">
                                    <button *ngIf="currentEquipement.id !== 0 && isAdmin" type="button" (click)="delete(equipement.id)" class="-ml-4" mat-button [color]="'warn'">Supprimer</button>
                                    <div class="flex items-center">
                                        <div class="flex items-center mr-4">
                                            <ng-container *ngIf="success">
                                                <mat-icon class="text-green-500" [svgIcon]="'heroicons_outline:check'"></mat-icon>
                                                <span class="ml-2">Équipement mis à jour</span>
                                            </ng-container>
                                            <ng-container *ngIf="error">
                                                <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                                                <span class="ml-2">Erreur lors de l'enregistrement, réessayez!</span>
                                            </ng-container>
                                        </div>
                                        <button type="submit" mat-flat-button [color]="'primary'">
                                            Enregistrer
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
